import { FurnitureColumnType } from 'src/domain/models/FurnitureColumnType';

// biome-ignore lint/suspicious/noExplicitAny: need to check any object
export function isFurnitureColumnType(obj: any): obj is FurnitureColumnType {
    return typeof obj === 'object' && obj !== null && typeof obj.optionCount === 'number';
}

export function isPersistedFurnitureColumnType(value: unknown): value is FurnitureColumnType {
    return isFurnitureColumnType(value) && value.storeFurnitureExists;
}

export function getFurnitureZoneCellState(value: unknown): { editable: boolean; value: number | null } {
    if (!isPersistedFurnitureColumnType(value)) {
        return { editable: false, value: null };
    }

    return { editable: true, value: value.chainFurnitureZoneId };
}
